import { useState, useEffect } from "react";
import { cn } from "../lib/utils";

type ConfirmDialogState = {
	message: string;
	resolve: (value: boolean) => void;
} | null;

let dialogState: ConfirmDialogState = null;
let listeners: Array<() => void> = [];

export const confirmDialog = (message: string): Promise<boolean> => {
	return new Promise((resolve) => {
		dialogState = { message, resolve };
		listeners.forEach((l) => l());
	});
};

export const ConfirmDialog = () => {
	const [state, setState] = useState<ConfirmDialogState>(null);

	useEffect(() => {
		const update = () => setState(dialogState);
		listeners.push(update);
		return () => { listeners = listeners.filter((l) => l !== update); };
	}, []);

	if (!state) return null;

	const handleClose = (value: boolean) => {
		state.resolve(value);
		dialogState = null;
		setState(null);
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
			<div className={cn("glass-raised rounded-xl p-6 max-w-sm w-full shadow-2xl")}>
				<p className="text-white/90 mb-6 text-sm leading-relaxed">{state.message}</p>
				<div className="flex gap-3 justify-end">
					<button
						onClick={() => handleClose(false)}
						className="px-4 py-2 rounded-lg text-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors"
					>
						Cancel
					</button>
					<button
						onClick={() => handleClose(true)}
						className="px-4 py-2 rounded-lg text-sm bg-primary text-white hover:bg-primary-light transition-colors"
					>
						Confirm
					</button>
				</div>
			</div>
		</div>
	);
};
